import { call, put, takeLatest } from 'redux-saga/effects';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from './actions';
import { post, get } from '../../utils/api';
import { GET_NOTES_SUCCESS } from '../NotesPage/actions';
import ReactGA from 'react-ga';
import { SET_TEMPLATE_LIST } from '../Template/actions';
import swal from 'sweetalert';

function* login({ payload }) {
  try {
    const { data } = yield call(post, `/login`, payload, null, 'account');
    localStorage.setItem('access_token', data.token);

    const token = data.token;

    const response = yield call(get, `/me`, token);
    const userData = response.data;
    yield put({
      type: LOGIN_SUCCESS,
      payload: {
        token: token,
        email: userData.email,
        role: userData.role,
        phrases: userData.phrases,
        adminEmail: userData.adminEmail,
        lang: userData.lang,
        vocabulary: userData.vocabulary,
      },
    });
    const templates = userData.templates.length > 0 ? userData.templates : [];
    yield put({
      type: SET_TEMPLATE_LIST,
      payload: templates,
    });

    let notesData = [];
    try {
      const notes = yield call(get, `/notes/get`, token);
      const status = notes.status;

      if (status === 200) {
        notesData = notes?.data?.notes?.length > 0 ? notes.data.notes : [];
      } else if (status === 404) {
        notesData = [];
      } else {
        throw new Error('Unexpected status code');
      }
    } catch (notesError) {
      if (notesError.response && notesError.response.status === 404) {
        notesData = [];
      } else {
        throw notesError;
      }
    }

    ReactGA.event({
      category: 'dictation_web',
      action: 'login',
      label: userData.email.replace('@', '[at]'),
    });
    yield put({ type: GET_NOTES_SUCCESS, payload: notesData });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Something went wrong';
    yield call(swal, 'Error', errorMessage, 'error');
    yield put({ type: LOGIN_FAILURE, payload: errorMessage });
  }
}

export default [takeLatest(LOGIN_REQUEST, login)];
